import axios from "axios";
import { api } from "../config";

// default
axios.defaults.baseURL = api.API_URL;
// content type
axios.defaults.headers.post["Content-Type"] = "application/json";

function setAuthorization() {
  const authUser = JSON.parse(localStorage.getItem("authUser"));
  // Use the correct property for the token
  if (authUser && authUser.token) {
    axios.defaults.headers.common["Authorization"] = "Bearer " + authUser.token;
  } else {
    delete axios.defaults.headers.common["Authorization"];
  }
}

// NOTE: Call setAuthorization() after login and before any API call that needs auth
setAuthorization();

// intercepting to capture errors
axios.interceptors.response.use(
  function (response) {
    return response.data ? response.data : response;
  },
  function (error) {
    let message;
    if (error.response) {
      // The request was made and the server responded with a status code outside of 2xx
      switch (error.response.status) {
        case 500:
          message = "Internal Server Error";
          break;
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the data you are looking for could not be found";
          break;
        case 413:
          message = "The uploaded data is too large. Please reduce the size and try again.";
          break;
        default:
          message = error.response.data.message || error.message || "An error occurred";
      }
      return Promise.reject(new Error(message));
    } else if (error.request) {
      // The request was made but no response was received
      message = "No response received from server";
      return Promise.reject(new Error(message));
    } else {
      // Something happened in setting up the request that triggered an Error
      return Promise.reject(new Error(error.message || "An error occurred"));
    }
  }
);
/**
 * Sets the default authorization
 * @param {*} token
 */
// const setAuthorization = (token) => {
//   axios.defaults.headers.common["Authorization"] = "Bearer " + token;
// };

class APIClient {
  /**
   * Fetches data from given url
   */

  //  get = (url, params) => {
  //   return axios.get(url, params);
  // };
  get(url, params) {
    let response;

    let paramKeys = [];

    if (params && params) {
      Object.keys(params).map((key) => {
        let filterValue = params[key].toString();
        filterValue = filterValue.replace("e=>e.", "");
        paramKeys.push(key + "=" + filterValue);
        return paramKeys;
      });

      let queryString =
        paramKeys && paramKeys.length ? paramKeys.join("&") : "";

      response = axios.get(`${url}?${queryString}`, params);
    } else {
      response = axios.get(`${url}`, params);
    }

    return response;
  }
  /**
   * post given data to url
   */
  acreate(url, data) {
    return axios.post(url, data);
  }
  /**
   * Updates data
   */
  update(url, data) {
    return axios.patch(url, data);
  }

  put(url, data) {
    return axios.put(url, data);
  }
  /**
   * Delete
   */
  delete(url, config = {}) {
    return axios.delete(url, config);
  }
}

const getLoggedinUser = () => {
  const user = localStorage.getItem("authUser");
  if (!user) {
    return null;
  }
  return JSON.parse(user);
};

export { APIClient, setAuthorization, getLoggedinUser };
